import { useDispatch, useSelector, useStore } from "react-redux";
import type { RootState } from "./rootReducer";
import type { AppDispatch, AppStore } from "./makeStore";

// Typed react-redux hooks shared by both apps. Use these instead of the plain
// useDispatch / useSelector.
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
